<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col
          id="bcolbanner"
          lg="12"
        >
          <bCarouselHome />
        </b-col>
      </b-row>
      <b-row id="rowOferta">
        <b-col lg="12">
          <h1
            class="text-center mx-3 mt-3"
            style="color:white;"
          >
            Oferta
          </h1>
          <h3
            class="text-center mx-3 mb-3"
            style="color:white;"
          >
            Campus Virtual INDETEC
          </h3>
        </b-col>
      </b-row>

      <ofertaAcademica
        :asesor="asesores"
        :coordinador="coordinador"
      />

      <b-row class="m-3">
        <b-col lg="12">
          <hr class="mx-5">
          <h1 class="text-center mx-3 mt-3">
            Primer ingreso
          </h1>
          <h3 class="text-center mx-3 mb-3">
            Campus Virtual INDETEC
          </h3>
        </b-col>
      </b-row>
      <!-- Proceso ingreso -->
      <procesoIngreso />

      <!-- noticias  <noticias /> -->
      <b-row class="mt-3 ">
        <b-col lg="12">
          <h1 class="text-center mx-3">
            Comunidad
          </h1>
          <h3 class="text-center mx-3 mb-3">
            Campus Virtual INDETEC
          </h3>
        </b-col>
      </b-row>
      <!-- comunidad -->
      <div class="mx-lg-0 mx-1">
        <comunidad />
      </div>

      <b-row class="mt-3 ">
        <b-col lg="12">
          <h1 class="text-center mx-3">
            Comunidad Academica
          </h1>
          <h3 class="text-center mx-3 mb-3">
            Campus Virtual INDETEC
          </h3>
        </b-col>
      </b-row>

      <swiper
        :swiper-data="asesores"
      />
      <!-- temas de interés -->
      <temasInteres />

      <!-- mensajes publicos -->
      <section>
        <b-modal
          id="modal-center"
          ref="modal-msn"
          centered
          title="Atención"
          size="lg"
          button-size="sm"
          ok-only
          ok-title="Cerrar"
        >
          <div>
            <b-alert
              variant="primary"
              class="mt-1"
              show
            >
              <div class="alert-body">
                Apreciabe funcionario le informamos que algunos de nuestros servicios se han visto afectados por problemas en el suministro de energía eléctrica. <br>
                Lamentamos el inconveniente y estámos trabajando para que se reestablezca lo más rápido posible. <br>
                Agradecemos su comprensión. <br>
              </div>
            </b-alert>
          </div>
        </b-modal>
      </section>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BModal,
} from 'bootstrap-vue'
import { onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import ofertaAcademica from './components/oferta-academica/swiper-oferta-academica.vue'
import bCarouselHome from './components/banner-home.vue'
import procesoIngreso from './components/proceso-ingreso.vue'
import comunidad from './components/comunidad.vue'

import swiper from './components/comudidad-academica/swiper.vue'
import temasInteres from './components/temas-interes.vue'

export default {
  components: {
    BRow,
    BCol,
    ofertaAcademica,
    bCarouselHome,
    procesoIngreso,
    comunidad,
    swiper,
    temasInteres,
    BModal,
  },

  setup() {
    const asesores = computed(() => store.state.ofertaAcademica.asesores)

    const coordinador = computed(() => store.state.ofertaAcademica.coordinadores)

    const getAsesores = () => {
      store.dispatch('ofertaAcademica/loadAsesores')
    }
    const getCordinadores = () => {
      store.dispatch('ofertaAcademica/loadCoordinador')
    }
    onMounted(() => {
      getAsesores()
      getCordinadores()
    })

    return {
      asesores,
      coordinador,
    }
  },
}
</script>
<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-sweetalert.scss';
  .card-title{
    color:#aa9d6b;
  }
  .card{
    background-color:#f8f8f8;
  }
  h1, h2, h3, h4, h5{
  color:#aa9d6b;
  }
  #bcolbanner{
          padding: 0px !important;
          margin-top:-30px;
  }
  #rowOferta{
    background-color:#aa9d6b;
    margin-top: 0px;
  }
  @media only screen and (max-width: 600px) {
    h1, h3 {
      font-size: 16px;
    }
    #bcolbanner{
          margin-top:-26px;
    }
    #rowOferta{
      margin-top:-10px;
    }
  }
</style>
